import { TAnswersState } from '../types/internal';
import { TStep, TNextStep, EStepCode, TFormStoreData } from '../../../types/form';
import { includes, path } from 'ramda';

interface IParams {
  answersState: TAnswersState;
  currentStep: TStep;
  stepsToSkip: EStepCode[];
  formData: TFormStoreData;
}

/**
 * Находит шаг, следующий по отношению к currentStep
 * Если найденный следующий шаг необходимо пропустить, рекурсивно вызовется повторно, пока не найдет подходящий шаг
 * Пропущенные шаги тоже вернет
 * */
export const getNextStep = (params: IParams): TNextStep[] => {
  const steps: TNextStep[] = [];

  const inner = (params: IParams): void => {
    const {
      answersState,
      currentStep: { nextStep },
      stepsToSkip,
      formData,
    } = params;

    for (const rule of nextStep) {
      const { conditions, nextStepCode } = rule;
      let isRuleCorrect = true;

      for (const condition of conditions) {
        const { answerField, value: conditionValue } = condition;
        const value = path([answerField, 'value'], answersState);

        if (!value || !includes(value, conditionValue)) {
          isRuleCorrect = false;
          break;
        }
      }

      if (isRuleCorrect) {
        /**
         * Если следующий шаг - в списке пропускаемых, то рекурсивно находим последующий шаг
         * */
        if (stepsToSkip.includes(nextStepCode)) {
          steps.push(rule);
          const currentStep = formData.schema.steps.find(step => step.code === nextStepCode) as TStep;

          return inner({ ...params, currentStep });
        }

        steps.push(rule);

        return;
      }
    }
  };

  inner(params);

  return steps;
};
